import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import "../stili/Login.css";

const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:8080").replace(/\/$/, "");

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const ruoloRedirectMap = {
    ROLE_ADMIN: "/gestionale",
    ROLE_STAFF: "/gestionale1",
    ROLE_GENITORE: "/gestionale2",
    ROLE_ALLENATORE: "/gestionale3",
  };

  const normalizeRuolo = (ruoloRaw) => {
    if (!ruoloRaw || typeof ruoloRaw !== "string") return "";
    const upper = ruoloRaw.trim().toUpperCase();
    return upper.startsWith("ROLE_") ? upper : `ROLE_${upper}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    setError("");

    const cleanUsername = username.trim();
    const cleanPassword = password;

    if (!cleanUsername || !cleanPassword) {
      setError("Inserisci username e password");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: cleanUsername,
          password: cleanPassword,
        }),
      });

      let data = null;
      try {
        data = await res.json();
      } catch {
        data = null;
      }

      if (!res.ok) {
        if (res.status === 401) {
          setError("Username o password errati");
        } else if (res.status === 403) {
          setError("Utente disattivato o accesso negato");
        } else {
          setError(data?.message || `Errore server: ${res.status}`);
        }
        return;
      }

      const accessToken = data?.accessToken;
      const refreshToken = data?.refreshToken;
      const ruolo = normalizeRuolo(data?.ruolo);
      const user = data?.username || cleanUsername;

      if (!accessToken || !refreshToken || !ruolo || !user) {
        setError("Dati mancanti dal server (token, ruolo o username)");
        return;
      }

      login({
        accessToken,
        refreshToken,
        ruolo,
        username: user,
      });

      const redirect = ruoloRedirectMap[ruolo];

      if (redirect) {
        navigate(redirect, { replace: true });
      } else {
        setError("Ruolo non riconosciuto");
      }
    } catch (err) {
      console.error("Errore login:", err);
      setError("Errore di connessione al server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit} autoComplete="on">
        <h2 className="login-title">Login</h2>

        <input
          className="login-input"
          type="text"
          name="username"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          required
        />

        <input
          className="login-input"
          type="password"
          name="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />

        <button type="submit" className="login-button" disabled={loading}>
          {loading ? "Accesso in corso..." : "Accedi"}
        </button>

        {error && (
          <div className="login-error-card">
            <p className="login-error">{error}</p>
          </div>
        )}
      </form>

      <div className="login-button-row">
        <button
          className="login-home-button"
          type="button"
          onClick={() => navigate("/")}
        >
          Torna alla Home Page
        </button>
      </div>
    </div>
  );
}